import React, { useState, useEffect } from "react";
import { Row, Col, Card, Typography, message, Divider, Table, Input, Space, Select, Spin } from "antd";
import { SearchOutlined, UserOutlined, LoadingOutlined, ApartmentOutlined } from "@ant-design/icons";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import { HeaderPage } from "../../../components/headerPage";
import http from "../../../services/http";
const { Text } = Typography;
const antIcon = <LoadingOutlined style={{ fontSize: 18 }} spin />;
const optionsFiltro = [
  { value: 0, label: "Todos" },
  { value: 1, label: "Marcados" },
  { value: 2, label: "Não Marcados" },
];

export const ProblemasPerfisSistemasOrigemVisualizacao = () => {
  const { id_colaborador } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // DADOS
  const [dados, setDados] = useState([]);
  const [selected, setSelected] = useState([]);

  // FILTRO
  const [marcado, setMarcado] = useState(0);
  const [search, setSearch] = useState("");

  // DADOS PERFIl
  const [colaborador, setColaborador] = useState({});

  useEffect(() => {
    if (id_colaborador) {
      carregarColaborador(id_colaborador);
      listarFiliais(id_colaborador);
    }
  }, [id_colaborador]);

  // CARREGAR COLABORADOR
  const carregarColaborador = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/usuario/carregar_colaborador/${id}`, []);
    if (api.statusCode === 200) {
      if (!api.response.data) {
        navigate("/planos-acao/perfis");
      }
      setColaborador(api.response.data);
    } else {
      navigate("/planos-acao/perfis");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR
  const listarFiliais = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/problemas_perfis_sistemas_origem/listar/${id}`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data.data);
      setSelected(api.response.data.checked);
    } else {
      navigate("/planos-acao/perfis");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // SALVAR
  const salvarSistemasOrigem = async (sis_origem_selected, sis_origem, id) => {
    setLoading(true);

    let array_sis_origem = [];
    sis_origem?.map((e) => {
      array_sis_origem.push(e.key);
    });

    const dados_envio = {
      id_colaborador: id,
      id_sistemas_origem: array_sis_origem,
      id_sistemas_origem_checked: sis_origem_selected,
    };

    const api = await http("post", `v1/problemas_perfis_sistemas_origem/adicionar`, dados_envio);
    if (api.statusCode === 200) {
      setSelected((array) =>
        array.filter(function (x) {
          return array_sis_origem.indexOf(x) < 0;
        })
      );
      setSelected((val) => [...val, ...sis_origem_selected]);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: (
        <div style={{ height: 23 }}>
          Sistema Origem <Spin indicator={antIcon} spinning={loading} />
        </div>
      ),
      dataIndex: "descricao",
      sorter: (a, b) => a.descricao?.localeCompare(b.descricao),
    },
  ];

  // PESQUISAR
  const handleFilter = (pesquisar, marcado) => {
    let filteredData = dados?.filter((val) => val.descricao?.toLowerCase().includes(pesquisar.toLowerCase()));

    switch (marcado) {
      case 1:
        filteredData = filteredData.filter((e) => {
          return selected.indexOf(e.id) === -1 ? false : true;
        });
        break;
      case 2:
        filteredData = filteredData.filter((e) => {
          return selected.indexOf(e.id) === -1 ? true : false;
        });
        break;
      default:
        break;
    }

    return filteredData;
  };

  // DADOS FILTRADOS
  const dadosFilter = dados?.length > 0 ? handleFilter(search, marcado) : [];

  // CHECK ROW
  const rowSelection = {
    type: "checkbox",
    disabled: true,
    selectedRowKeys: selected,
    onSelectAll: (e) => {
      if (loading) return;
      let array = [];
      if (e === true) array = dadosFilter.map((e) => e.key);
      salvarSistemasOrigem(array, dadosFilter, id_colaborador);
    },
    onSelect: (data, status) => {
      if (loading) return;
      salvarSistemasOrigem(status ? [data.key] : [], [{ key: data.key }], id_colaborador);
    },
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Planos de Ação" onClickBack={() => navigate("/planos-acao/perfis")} />
            <HeaderTitle
              title="Perfis Grupos Origem"
              subtitle={
                <Text italic>
                  <UserOutlined /> {colaborador?.nome ?? ""}
                </Text>
              }
              icon={<ApartmentOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space direction="vertical">
                <Space wrap>
                  <Input
                    size="middle"
                    maxLength={100}
                    prefix={<SearchOutlined />}
                    className="input"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Pesquisar..."
                    allowClear
                  />
                  <Select
                    defaultValue={0}
                    value={marcado}
                    style={{ width: 180, maxWidth: "100%" }}
                    onChange={(e) => setMarcado(e)}
                    options={optionsFiltro}
                  />
                </Space>
              </Space>

              <Divider />

              <Table
                loading={loading}
                scroll={{ x: 700 }}
                columns={columns}
                rowSelection={rowSelection}
                dataSource={dadosFilter}
                size="small"
              />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
